'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var assert = require('./assert');

var _require = require('./utils/collections'),
    mapValues = _require.mapValues;

var promise = require('./utils/promise');

var _require2 = require('./utils/log'),
    log = _require2.log;

var BiLogger = function () {
  //TODO: validate args
  function BiLogger(options, context) {
    _classCallCheck(this, BiLogger);

    this._publishers = options.publishers;
    this._validators = options.validators || [];
    this._defaults = options.defaults;
    this._events = options.events || {};
    this._context = context;
    this._defaultValueTimeout = options.defaultValueTimeout || 5000;
    this._defaultContinueOnFail = options.defaultContinueOnFail || false;
  }

  _createClass(BiLogger, [{
    key: 'log',
    value: function log(eventOrKey, eventOrUndefined) {
      var _this = this;

      assert.defined(eventOrKey, 'Event object or event key must be provided.');
      var event = this._eventOrExtractFromEvents(eventOrKey, eventOrUndefined);

      var validatorsResult = this._validators.length === 0 ? true : this._validators.some(function (validator) {
        return validator.match(event) && (validator.execute(event) || true);
      });

      if (!validatorsResult) {
        throw new Error('No validator accepted the event');
      }

      return this._getDefaults().then(function (defaults) {
        return Promise.all(_this._publishers.map(function (publish) {
          var cloned = Object.assign({}, defaults, event);

          return Promise.resolve().then(function () {
            return publish(cloned, _this._context);
          }).catch(function (error) {
            if (error && error.message && error.stack) {
              error.message = 'Publisher \'' + publish.name + '\' failed with error: \'' + error.message + '\'';
            }

            return Promise.reject(error);
          });
        }));
      });
    }
  }, {
    key: '_eventOrExtractFromEvents',
    value: function _eventOrExtractFromEvents(eventOrKey, eventOrUndefined) {
      if (typeof eventOrKey !== 'string') {
        return eventOrKey;
      }
      var event = this._events[eventOrKey];
      if (!event) {
        throw new assert.AssertionError('Event with key \'' + eventOrKey + '\' not found in event map.');
      }

      if (eventOrUndefined) {
        return Object.assign({}, event, eventOrUndefined);
      } else {
        return event;
      }
    }
  }, {
    key: '_getDefaults',
    value: function _getDefaults() {
      var _this2 = this;

      if (!this._defaults) {
        return Promise.resolve({});
      }

      var promises = mapValues(this._defaults, function (value, key) {
        if (value && typeof value.then !== 'function') {
          return value;
        }
        return promise.timedPromise(value, {
          message: 'Cannot get default value \'' + key + ' for BI Event\'',
          timeout: _this2._defaultValueTimeout
        }).catch(function (err) {
          if (_this2._defaultContinueOnFail) {
            log.error(err);
            return null;
          }
          return Promise.reject(err);
        });
      });

      return promise.allAsObject(promises);
    }
  }]);

  return BiLogger;
}();

module.exports = BiLogger;
//# sourceMappingURL=bi-logger.js.map


//////////////////
// WEBPACK FOOTER
// ../~/wix-bi-logger-client/dist/bi-logger.js
// module id = 315
// module chunks = 0 1